<!--
   Created by qing on 2020/12/19
   Des: 新建、编辑目录
-->
<template>
  <van-popup
    class="node-add-popup"
    v-model="visibleInfo.visible"
    :overlay="false"
    get-container="body"
    :style="{ height: '100%', width: '100%' }"
    @close="beforeClose"
    position="right">
    <div class="node-add-container" v-if="node">

      <div class="content">
        <div class="base-info">
          <van-field
            ref="titleField"
            v-model="node.nodeName"
            name="标题"
            label="标题"
            :required="true"
            :rules="[{ required: true, message: '请填写标题' }]"
          />

          <van-cell class="ry-form__rtf">
            <template slot="title">
              <span class="title" style="color: #646566;">内容</span>

            </template>
            <template slot="label">
              <ry-quill-editor
                placeholder="请输入内容"
                :content.sync="node.nodeContent">
              </ry-quill-editor>
            </template>
          </van-cell>

          <van-field label="上传附件">
            <template #input>
              <div style="display: flex; flex-direction: column; width: 100%;">

                <el-button
                  style="width: 90px; padding: 5px 0"
                  type="text"
                  icon="el-icon-paperclip"
                  @click.stop.prevent.left="selectFile"
                >上传附件
                </el-button>

                <ul class="file__list" v-if="node.attachmentList.length">
                  <li v-for="(file, idx) in node.attachmentList">
                    <div class="file__icon">
                      <svg class="icon" aria-hidden="true">
                        <use :xlink:href="actionFileType2FileImage(file.fileType)"></use>
                      </svg>
                    </div>
                    <div class="file__info">
                      <div class="file__info-name">
                        {{file.fileName}}
                      </div>
                      <div class="file__info-bottom">

                        <div class="file__info-size">
                          {{file.fileSize}}KB
                        </div>
                        <div class="file__info-handle">
                          <div
                            class="handle-button"
                            @click.stop.prevent.left="previewFile(file)">
                            预览
                          </div>
                          <div class="divider"></div>
                          <div
                            style="color: red"
                            class="handle-button"
                            @click.stop.prevent.left="node.attachmentList.splice(idx, 1)">
                            删除
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>

                  <file-preview-popup
                    ref="filePreviewPopup"
                    :stackList="stackList"
                  ></file-preview-popup>
                </ul>
              </div>
            </template>
          </van-field>

        </div>

        <van-field label="负责人" style="margin-top: 10px">
          <template #input>
            <ContactBox
              :field="chargeUserConfig"
              :user-id="$store.state.userId"
              :company-id="$store.state.companyId"
              :multiple="false"
              :hasDep="false"
              :hasRole="false"
              :has-ext="false"
              :has-label="false"
              :selectedMember="selectChargeUser"
              :selectedExt="selectChargeUser"
              @change="chargeUserChange"
              @selectedComplete="chargeUserChange">
            </ContactBox>
          </template>
        </van-field>
        <van-field label="参与人" style="margin-top: 10px">
          <template #input>
            <ContactBox
              :field="participantConfig"
              :user-id="$store.state.userId"
              :company-id="$store.state.companyId"
              multiple
              :selectedMember="node.participant.member"
              :selectedDep="node.participant.depart"
              :selectedRole="node.participant.role"
              :selectedExt="node.participant.external"
              :selectedLabel="node.participant.externalTag"
              @selectedComplete="selectedParticipantComplete">
            </ContactBox>
          </template>
        </van-field>

        <van-field label="卡片显示负责人、参与人头像" class="custom-field" style="margin-top: 10px">
          <template #input>
            <van-switch
              v-model="node.showImage"
              :active-value="1"
              :inactive-value="0"
              size="20"/>
          </template>
        </van-field>

        <van-field :label="`${$store.getters.mix_form_name}参与人可查看此目录`" class="custom-field">
          <template #input>
            <van-switch
              v-model="node.viewByMixForm"
              :active-value="1"
              :inactive-value="0"
              size="20"/>
          </template>
        </van-field>
      </div>

      <div class="footer">
        <van-button
          @click="cancel">
          取 消
        </van-button>
        <van-button
          type="primary"
          @click="submitData">
          确定
        </van-button>
      </div>
    </div>
  </van-popup>
</template>

<script>
  import {accurateFormatDate, fileType2FileImage, getSimpleText, clone} from "../../../assets/js/Untis";
  import {uuid} from "../../RyForm/utils";
  import FilePreviewPopup from "./FilePreviewPopup";

  export default {
    props: {
      mixFormId: {
        type: String,
        default: ''
      },
      stackList: {
        type: Array,
        default: () => []
      },
      chargeUserConfig: Object,
      participantConfig: Object
    },
    components: {FilePreviewPopup},
    data() {
      return {
        visibleInfo: {
          nodeId: '',
          visible: false
        },
        node: null,
        isCreate: true,
        fileInput: null,
        showLoading: false
      }
    },
    created() {
    },
    computed: {

      selectChargeUser: {
        set(val) {
          this.node.chargeUser = val[0]
        },
        get() {
          if (this.node.chargeUser) {
            return [this.node.chargeUser]
          } else {
            return []
          }
        }
      },
    },
    methods: {

      actionFileType2FileImage(fileType) {
        return fileType2FileImage(fileType)
      },
      async open({nodeId, parentId}) {
        if (nodeId) {
          this.node = await this.$store.dispatch('actionMixFormNodeDetail', {
            mixFormId: this.mixFormId,
            nodeId: nodeId
          }).catch(console.error)

          this.title = `编辑【${this.node.nodeName}】`
          this.isCreate = false
        } else {
          this.isCreate = true
          this.title = '新建目录'
          this.node = {
            mixFormId: this.mixFormId,
            parentId, //根节点为空,
            sortIndex: 1, //排序
            nodeName: "", //目录名称
            nodeContent: "",
            attachmentList: [],
            childrenIdList: [],
            nodeColor: "#63B2EE", // 卡片颜色
            nodeIcon: "", // 图标
            chargeUser: this.$store.state.userInfo.userId, //负责人
            participant: {
              depart: [],
              member: [],
              role: [],
              external: [],
              externalTag: []
            },
            itemList: [],
            showImage: 0, // 卡片是否显示头像
            viewByMixForm: 1 // 融合表参与人可查看此目录
          }
        }

        if (!this.fileInput) {
          this.fileInput = document.createElement('input')
          this.fileInput.setAttribute('type', 'file')
          this.fileInput.onchange = this.fileChange
        }

        this.visibleInfo.nodeId = nodeId
        this.stackList.push(this.visibleInfo)
        this.visibleInfo.visible = true

        this.$nextTick(() => {
          console.log('titleField', this.$refs.titleField)
          if (this.$refs.titleField) {
            const input = this.$refs.titleField.$el.querySelector('input')
            input.focus()
          }
        })
      },
      beforeClose() {
        this.$emit('close')
      },
      selectFile() {
        this.fileInput.click()
      },

      fileChange(e) {
        const file = e.target.files[0]
        const fileInfo = {
          fileName: file.name,
          fileSize: (file.size / 1000).toFixed(2),
          fileUrl: '',
          fileType: file.type || file.name.split('.').slice(-1)[0],
          id: uuid('FILE')
        }
        this.showLoading = true
        this.$RyFs.upload(e.target.files)
          .then(res => {
            fileInfo.fileUrl = res[0]
            this.node.attachmentList.push(fileInfo)
            this.showLoading = false
          })
          .catch(err => {
            this.$toast.fail('上传失败')
            console.error(err)
            this.showLoading = false
          })
          .finally(() => {
            this.fileInput.value = ''
          })
      },

      chargeUserChange(selected) {
        if (selected) {
          // change方法返回的是member， complete方法返回的是memberIds
          if (selected.hasOwnProperty('memberIds') && selected.memberIds.length) {
            this.node.chargeUser = selected.memberIds[0]
          } else if (selected.hasOwnProperty('extIds') && selected.extIds.length) {
            this.node.chargeUser = selected.extIds[0]
          } else {
            this.node.chargeUser = selected.member[0]
          }
        }
      },
      selectedParticipantComplete(selected) {
        if (selected) {
          this.node.participant.member = selected.memberIds
          this.node.participant.depart = selected.depIds
          this.node.participant.role = selected.roleIds
          this.node.participant.external = selected.extIds
          this.node.participant.externalTag = selected.labelIds
        }
      },
      previewFile(file) {

        if (this.$refs.filePreviewPopup) {
          this.$refs.filePreviewPopup.open(file, 'MIX_FORM')
        }

      },

      cancel() {
        const visibleInfo = this.stackList.pop()
        visibleInfo.visible = false
      },
      submitData() {
        if (!this.node.nodeName) {
          this.$toast.fail('请填写目录名称')
          return
        }
        if (!this.node.chargeUser) {
          this.$toast.fail('请选择负责人')
          return
        }
        const loading = this.$toast.loading()
        if (this.isCreate) {
          this.$store.dispatch('actionMixFormNodeCreate', this.node)
            .then(res => {
              this.$toast.success('创建成功')
              this.$set(this.node, 'nodeId', res.nodeId)
              this.$emit('createNodeSuccess', this.node)
              this.cancel()
            })
            .catch(console.error)
            .finally(() => {
              loading.clear()
            })
        } else {
          this.$store.dispatch('actionMixFormNodeUpdate', {
            mixFormId: this.mixFormId,
            ...this.node
          })
            .then(res => {
              this.$toast.success('更新成功')
              this.$emit('updateNodeSuccess', this.node)
              this.cancel()
            })
            .catch(console.error)
            .finally(() => {
              loading.clear()
            })
        }
      }
    }
  }
</script>

<style lang="less">

  .node-add-popup {

    .node-add-container {
      background-color: #F6F6F6;
      width: 100%;
      height: calc(100% - env(safe-area-inset-bottom));
      position: relative;
      overflow: hidden;

      .content {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 44px;
        overflow: auto;

        .base-info {
          margin-top: 10px;
        }

        .custom-field {
          .van-field__label {
            width: 200px;
          }
        }
      }

      .footer {
        background-color: #fff;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 44px;
        display: flex;
        justify-content: space-around;
        align-items: center;

        .van-button {
          width: 50%;
          border-radius: 0;
        }
      }
    }
  }
</style>